import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import clsx from "clsx";
import { GeneralInformationItem } from "@app/types/dashboard.type";

interface GeneralInformationDashboardModalProps {
  data: GeneralInformationItem[];
  icon: any;
}

export const backGroundColors = [
  "bg-[#5570F1]",
  "bg-[#771BCC]",
  "bg-[#FFAB00]",
];

function GeneralInformationDashboardModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<GeneralInformationDashboardModalProps>) {
  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="relative py-[60px] px-[60px] text-white">

        <div className=" flex flex-wrap justify-start gap-[24px]">
          {portalData?.data?.map((item, index) => (
            <div
              key={index}
              className={clsx(
                "w-[193px] h-[140px] rounded-[12px] flex flex-col gap-4 p-[24px]",
                backGroundColors[index]
              )}
            >
              <div className="flex gap-4 items-center">
                <div className="w-[40px] h-[40px] bg-[#FFFFFF] bg-opacity-20 rounded-[8px] flex items-center justify-center">
                  <portalData.icon />
                </div>
                <p className="text-[24px] font-medium">{item.value}</p>
              </div>
              <p className="text-[14px]">{item.lable}</p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default GeneralInformationDashboardModal;
